exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___1ZL8g{text-align:center}.style__img___3DBeh{display:inline-block;position:relative;z-index:3}.style__clip___k2eKt{position:absolute;background-color:#f8d0ca;top:400px;bottom:0;left:0;right:0;z-index:1}.style__patternLeft___WLydE{position:fixed;top:0;left:0;z-index:2}.style__patternRight___3bewN{position:fixed;top:0;right:0;z-index:0}@media (max-width:1499px){.style__diamond___1vCs_{width:500px}.style__clip___k2eKt{-webkit-clip-path:polygon(0 0,0 100%,260% 100%);clip-path:polygon(0 0,0 100%,260% 100%)}.style__patternLeft___WLydE{width:375px}.style__patternRight___3bewN{width:600px}}@media (min-width:1500px){.style__diamond___1vCs_{width:750px}.style__clip___k2eKt{-webkit-clip-path:polygon(0 0,0 100%,170% 100%);clip-path:polygon(0 0,0 100%,170% 100%)}}@media (min-width:2100px){.style__diamond___1vCs_{width:750px;padding-top:180px}.style__clip___k2eKt{-webkit-clip-path:polygon(0 0,0 100%,170% 100%);clip-path:polygon(0 0,0 100%,170% 100%);top:500px}.style__patternLeft___WLydE{width:600px}.style__patternRight___3bewN{width:1000px;top:50px}}", ""]);

// exports
exports.locals = {
	"container": "style__container___1ZL8g",
	"img": "style__img___3DBeh",
	"clip": "style__clip___k2eKt",
	"patternLeft": "style__patternLeft___WLydE",
	"patternRight": "style__patternRight___3bewN",
	"diamond": "style__diamond___1vCs_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/welcome-images/style.css
// module id = 713
// module chunks = 0